import axios from "axios";
import { authHeader } from "./authHeader";


const API_URL = process.env.REACT_APP_API_URL;

// Get Assign Leads
const getAssignLeads = (params) => {
    return axios.get(API_URL + '/api/assignLeads', {
        params:params,
        headers:authHeader()
    });
}

// Get Assign Lead By Id
const getAssignLeadById = (assignLeads_id) => {
    return axios.get(API_URL + `/api/assignLeads/${assignLeads_id}`, {headers:authHeader()});
}

// Create Assign Leads
const createAssignLead = (formData) => {
    return axios.post(API_URL + '/api/assignLeads',formData,{headers:authHeader()});
}

// Update Assign Lead
const updateAssignLead = (assignLeads_id, formData) => {
    return axios.put(API_URL + `/api/assignLeads/update/${assignLeads_id}`,formData, {headers:authHeader()});
}

// Delete Assign Lead
const deleteAssignLead = (assignLeads_id) => {
    return axios.delete(API_URL + `/api/assignLeads/delete/${assignLeads_id}`, {headers:authHeader()});
}

const ASSIGNLEADAPI = {getAssignLeads,getAssignLeadById,createAssignLead,updateAssignLead,deleteAssignLead};

export default ASSIGNLEADAPI;